export default {
  // LSX语言配置
  is_warehouse_address_consistent_with_shop_backend_shipping_address:
    "仓库地址和店铺后台发货地址是否一致",
  is_use_account_to_handle_product_prefix: "是否使用账号处理商品前缀",
  is_default_print_product_barcode_company: "是否默认打印商品条码公司",
  set_shop_group: "设置店铺分组",
  please_select_shop_group: "请选择店铺分组",
  contain_shop: "包含店铺",
  my_pending_task: "我的待办",
  pending_task_category: "待办分类",
  pending_task_title: "待办标题",

  please_select_pending_task_category: "请选择待办分类",
  unprocessed: "未处理",
  processed: "已处理",
  todoList: "待办列表",
  pending_task_content: "待办内容",
  refresh: "刷新",
  id_card_number: "身份证号",
  permission_info: "权限信息",
  employee_name: "员工姓名",
  productSKUList: "商品SKU列表",
};
